module.exports = __webpack_public_path__ + "img/Linkedin_hover.cfe8e928.svg";